import { render, staticRenderFns } from "./posRegionalModal.vue?vue&type=template&id=042b7948&"
import script from "./posRegionalModal.vue?vue&type=script&lang=js&"
export * from "./posRegionalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports